module.exports = "/_next/static/images/creator-abstract-cover-800-4b2ae134d2bd772a95561379a313e069.webp";